import React from "react";
import { NavLink } from "react-router-dom";

function MenuInteremedioActividades() {
  return (
    <nav className="activity-nav-strip" aria-label="Secciones de actividades">
      <NavLink to="/deportes" className="activity-nav-link">
        Educación Física
      </NavLink>
      <NavLink to="/arteActividad" className="activity-nav-link">
        Arte
      </NavLink>
      <NavLink to="/actividades" className="activity-nav-link">
        Comunidad Activa
      </NavLink>
    </nav>
  );
}

export default MenuInteremedioActividades;
